var _e = (t) => {
  throw TypeError(t);
};
var me = (t, e, s) => e.has(t) || _e("Cannot " + s);
var n = (t, e, s) => (me(t, e, "read from private field"), s ? s.call(t) : e.get(t)), f = (t, e, s) => e.has(t) ? _e("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, s), c = (t, e, s, r) => (me(t, e, "write to private field"), r ? r.call(t, s) : e.set(t, s), s), m = (t, e, s) => (me(t, e, "access private method"), s);
import * as T from "react";
import { createContext as ft, useContext as yt } from "react";
import { j as pt } from "./jsx-runtime-Bdg6XQ1m.js";
import { u as pe, m as bt } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
var Qe = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, V = typeof window > "u" || "Deno" in globalThis;
function ge() {
}
function Zt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Se(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function et(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function fe(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function x(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Wt(t, e) {
  const {
    type: s = "all",
    exact: r,
    fetchStatus: i,
    predicate: o,
    queryKey: a,
    stale: u
  } = t;
  if (a) {
    if (r) {
      if (e.queryHash !== mt(a, e.options))
        return !1;
    } else if (!qe(e.queryKey, a))
      return !1;
  }
  if (s !== "all") {
    const l = e.isActive();
    if (s === "active" && !l || s === "inactive" && l)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || i && i !== e.state.fetchStatus || o && !o(e));
}
function Jt(t, e) {
  const { exact: s, status: r, predicate: i, mutationKey: o } = t;
  if (o) {
    if (!e.options.mutationKey)
      return !1;
    if (s) {
      if (Re(e.options.mutationKey) !== Re(o))
        return !1;
    } else if (!qe(e.options.mutationKey, o))
      return !1;
  }
  return !(r && e.state.status !== r || i && !i(e));
}
function mt(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Re)(t);
}
function Re(t) {
  return JSON.stringify(
    t,
    (e, s) => Ee(s) ? Object.keys(s).sort().reduce((r, i) => (r[i] = s[i], r), {}) : s
  );
}
function qe(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((s) => !qe(t[s], e[s])) : !1;
}
function Ce(t, e) {
  if (t === e)
    return t;
  const s = He(t) && He(e);
  if (s || Ee(t) && Ee(e)) {
    const r = s ? t : Object.keys(t), i = r.length, o = s ? e : Object.keys(e), a = o.length, u = s ? [] : {};
    let l = 0;
    for (let S = 0; S < a; S++) {
      const v = s ? S : o[S];
      (!s && r.includes(v) || s) && t[v] === void 0 && e[v] === void 0 ? (u[v] = void 0, l++) : (u[v] = Ce(t[v], e[v]), u[v] === t[v] && t[v] !== void 0 && l++);
    }
    return i === a && l === i ? t : u;
  }
  return e;
}
function we(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const s in t)
    if (t[s] !== e[s])
      return !1;
  return !0;
}
function He(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Ee(t) {
  if (!Be(t))
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const s = e.prototype;
  return !(!Be(s) || !s.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(t) !== Object.prototype);
}
function Be(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function vt(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Oe(t, e, s) {
  if (typeof s.structuralSharing == "function")
    return s.structuralSharing(t, e);
  if (s.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Ce(t, e);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${s.queryHash}]: ${r}`
        );
      }
    return Ce(t, e);
  }
  return e;
}
function Xt(t, e, s = 0) {
  const r = [...t, e];
  return s && r.length > s ? r.slice(1) : r;
}
function Yt(t, e, s = 0) {
  const r = [e, ...t];
  return s && r.length > s ? r.slice(0, -1) : r;
}
var ye = Symbol();
function gt(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === ye && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${t.queryHash}'`
  ), !t.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !t.queryFn || t.queryFn === ye ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`)) : t.queryFn;
}
var K, q, J, Ze, St = (Ze = class extends Qe {
  constructor() {
    super();
    f(this, K);
    f(this, q);
    f(this, J);
    c(this, J, (e) => {
      if (!V && window.addEventListener) {
        const s = () => e();
        return window.addEventListener("visibilitychange", s, !1), () => {
          window.removeEventListener("visibilitychange", s);
        };
      }
    });
  }
  onSubscribe() {
    n(this, q) || this.setEventListener(n(this, J));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = n(this, q)) == null || e.call(this), c(this, q, void 0));
  }
  setEventListener(e) {
    var s;
    c(this, J, e), (s = n(this, q)) == null || s.call(this), c(this, q, e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(e) {
    n(this, K) !== e && (c(this, K, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((s) => {
      s(e);
    });
  }
  isFocused() {
    var e;
    return typeof n(this, K) == "boolean" ? n(this, K) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, K = new WeakMap(), q = new WeakMap(), J = new WeakMap(), Ze), tt = new St(), X, A, Y, We, Rt = (We = class extends Qe {
  constructor() {
    super();
    f(this, X, !0);
    f(this, A);
    f(this, Y);
    c(this, Y, (e) => {
      if (!V && window.addEventListener) {
        const s = () => e(!0), r = () => e(!1);
        return window.addEventListener("online", s, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", s), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    n(this, A) || this.setEventListener(n(this, Y));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = n(this, A)) == null || e.call(this), c(this, A, void 0));
  }
  setEventListener(e) {
    var s;
    c(this, Y, e), (s = n(this, A)) == null || s.call(this), c(this, A, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    n(this, X) !== e && (c(this, X, e), this.listeners.forEach((r) => {
      r(e);
    }));
  }
  isOnline() {
    return n(this, X);
  }
}, X = new WeakMap(), A = new WeakMap(), Y = new WeakMap(), We), st = new Rt();
function Fe() {
  let t, e;
  const s = new Promise((i, o) => {
    t = i, e = o;
  });
  s.status = "pending", s.catch(() => {
  });
  function r(i) {
    Object.assign(s, i), delete s.resolve, delete s.reject;
  }
  return s.resolve = (i) => {
    r({
      status: "fulfilled",
      value: i
    }), t(i);
  }, s.reject = (i) => {
    r({
      status: "rejected",
      reason: i
    }), e(i);
  }, s;
}
function Ct(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function rt(t) {
  return (t ?? "online") === "online" ? st.isOnline() : !0;
}
var nt = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
};
function ve(t) {
  return t instanceof nt;
}
function wt(t) {
  let e = !1, s = 0, r = !1, i;
  const o = Fe(), a = (b) => {
    var p;
    r || (R(new nt(b)), (p = t.abort) == null || p.call(t));
  }, u = () => {
    e = !0;
  }, l = () => {
    e = !1;
  }, S = () => tt.isFocused() && (t.networkMode === "always" || st.isOnline()) && t.canRun(), v = () => rt(t.networkMode) && t.canRun(), h = (b) => {
    var p;
    r || (r = !0, (p = t.onSuccess) == null || p.call(t, b), i == null || i(), o.resolve(b));
  }, R = (b) => {
    var p;
    r || (r = !0, (p = t.onError) == null || p.call(t, b), i == null || i(), o.reject(b));
  }, g = () => new Promise((b) => {
    var p;
    i = (E) => {
      (r || S()) && b(E);
    }, (p = t.onPause) == null || p.call(t);
  }).then(() => {
    var b;
    i = void 0, r || (b = t.onContinue) == null || b.call(t);
  }), w = () => {
    if (r)
      return;
    let b;
    const p = s === 0 ? t.initialPromise : void 0;
    try {
      b = p ?? t.fn();
    } catch (E) {
      b = Promise.reject(E);
    }
    Promise.resolve(b).then(h).catch((E) => {
      var be;
      if (r)
        return;
      const U = t.retry ?? (V ? 0 : 3), N = t.retryDelay ?? Ct, ce = typeof N == "function" ? N(s, E) : N, le = U === !0 || typeof U == "number" && s < U || typeof U == "function" && U(s, E);
      if (e || !le) {
        R(E);
        return;
      }
      s++, (be = t.onFail) == null || be.call(t, s, E), vt(ce).then(() => S() ? void 0 : g()).then(() => {
        e ? R(E) : w();
      });
    });
  };
  return {
    promise: o,
    cancel: a,
    continue: () => (i == null || i(), o),
    cancelRetry: u,
    continueRetry: l,
    canStart: v,
    start: () => (v() ? w() : g().then(w), o)
  };
}
function Et() {
  let t = [], e = 0, s = (u) => {
    u();
  }, r = (u) => {
    u();
  }, i = (u) => setTimeout(u, 0);
  const o = (u) => {
    e ? t.push(u) : i(() => {
      s(u);
    });
  }, a = () => {
    const u = t;
    t = [], u.length && i(() => {
      r(() => {
        u.forEach((l) => {
          s(l);
        });
      });
    });
  };
  return {
    batch: (u) => {
      let l;
      e++;
      try {
        l = u();
      } finally {
        e--, e || a();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (u) => (...l) => {
      o(() => {
        u(...l);
      });
    },
    schedule: o,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (u) => {
      s = u;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (u) => {
      r = u;
    },
    setScheduler: (u) => {
      i = u;
    }
  };
}
var Ae = Et(), _, Je, Ot = (Je = class {
  constructor() {
    f(this, _);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Se(this.gcTime) && c(this, _, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? (V ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    n(this, _) && (clearTimeout(n(this, _)), c(this, _, void 0));
  }
}, _ = new WeakMap(), Je), ee, te, I, C, ue, H, D, Q, Xe, es = (Xe = class extends Ot {
  constructor(e) {
    super();
    f(this, D);
    f(this, ee);
    f(this, te);
    f(this, I);
    f(this, C);
    f(this, ue);
    f(this, H);
    c(this, H, !1), c(this, ue, e.defaultOptions), this.setOptions(e.options), this.observers = [], c(this, I, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, c(this, ee, Ft(this.options)), this.state = e.state ?? n(this, ee), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = n(this, C)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...n(this, ue), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && n(this, I).remove(this);
  }
  setData(e, s) {
    const r = Oe(this.state.data, e, this.options);
    return m(this, D, Q).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: s == null ? void 0 : s.updatedAt,
      manual: s == null ? void 0 : s.manual
    }), r;
  }
  setState(e, s) {
    m(this, D, Q).call(this, { type: "setState", state: e, setStateOptions: s });
  }
  cancel(e) {
    var r, i;
    const s = (r = n(this, C)) == null ? void 0 : r.promise;
    return (i = n(this, C)) == null || i.cancel(e), s ? s.then(ge).catch(ge) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(n(this, ee));
  }
  isActive() {
    return this.observers.some(
      (e) => x(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === ye || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !et(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var s;
    const e = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (s = n(this, C)) == null || s.continue();
  }
  onOnline() {
    var s;
    const e = this.observers.find((r) => r.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (s = n(this, C)) == null || s.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), n(this, I).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((s) => s !== e), this.observers.length || (n(this, C) && (n(this, H) ? n(this, C).cancel({ revert: !0 }) : n(this, C).cancelRetry()), this.scheduleGc()), n(this, I).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || m(this, D, Q).call(this, { type: "invalidate" });
  }
  fetch(e, s) {
    var l, S, v;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (s != null && s.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (n(this, C))
        return n(this, C).continueRetry(), n(this, C).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const h = this.observers.find((R) => R.options.queryFn);
      h && this.setOptions(h.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), i = (h) => {
      Object.defineProperty(h, "signal", {
        enumerable: !0,
        get: () => (c(this, H, !0), r.signal)
      });
    }, o = () => {
      const h = gt(this.options, s), R = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return i(R), c(this, H, !1), this.options.persister ? this.options.persister(
        h,
        R,
        this
      ) : h(R);
    }, a = {
      fetchOptions: s,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: o
    };
    i(a), (l = this.options.behavior) == null || l.onFetch(
      a,
      this
    ), c(this, te, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((S = a.fetchOptions) == null ? void 0 : S.meta)) && m(this, D, Q).call(this, { type: "fetch", meta: (v = a.fetchOptions) == null ? void 0 : v.meta });
    const u = (h) => {
      var R, g, w, b;
      ve(h) && h.silent || m(this, D, Q).call(this, {
        type: "error",
        error: h
      }), ve(h) || ((g = (R = n(this, I).config).onError) == null || g.call(
        R,
        h,
        this
      ), (b = (w = n(this, I).config).onSettled) == null || b.call(
        w,
        this.state.data,
        h,
        this
      )), this.scheduleGc();
    };
    return c(this, C, wt({
      initialPromise: s == null ? void 0 : s.initialPromise,
      fn: a.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (h) => {
        var R, g, w, b;
        if (h === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), u(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(h);
        } catch (p) {
          u(p);
          return;
        }
        (g = (R = n(this, I).config).onSuccess) == null || g.call(R, h, this), (b = (w = n(this, I).config).onSettled) == null || b.call(
          w,
          h,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: u,
      onFail: (h, R) => {
        m(this, D, Q).call(this, { type: "failed", failureCount: h, error: R });
      },
      onPause: () => {
        m(this, D, Q).call(this, { type: "pause" });
      },
      onContinue: () => {
        m(this, D, Q).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), n(this, C).start();
  }
}, ee = new WeakMap(), te = new WeakMap(), I = new WeakMap(), C = new WeakMap(), ue = new WeakMap(), H = new WeakMap(), D = new WeakSet(), Q = function(e) {
  const s = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...it(r.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: e.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const i = e.error;
        return ve(i) && i.revert && n(this, te) ? { ...n(this, te), fetchStatus: "idle" } : {
          ...r,
          error: i,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: i,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...e.state
        };
    }
  };
  this.state = s(this.state), Ae.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), n(this, I).notify({ query: this, type: "updated", action: e });
  });
}, Xe);
function it(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: rt(e.networkMode) ? "fetching" : "paused",
    ...t === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Ft(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, s = e !== void 0, r = s ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: s ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: s ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var P, d, oe, F, B, se, M, k, he, re, ne, G, z, L, ie, y, ae, Pe, Ie, Te, De, xe, je, ke, ut, Ye, at = (Ye = class extends Qe {
  constructor(e, s) {
    super();
    f(this, y);
    f(this, P);
    f(this, d);
    f(this, oe);
    f(this, F);
    f(this, B);
    f(this, se);
    f(this, M);
    f(this, k);
    f(this, he);
    f(this, re);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    f(this, ne);
    f(this, G);
    f(this, z);
    f(this, L);
    f(this, ie, /* @__PURE__ */ new Set());
    this.options = s, c(this, P, e), c(this, k, null), c(this, M, Fe()), this.options.experimental_prefetchInRender || n(this, M).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(s);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (n(this, d).addObserver(this), Ge(n(this, d), this.options) ? m(this, y, ae).call(this) : this.updateResult(), m(this, y, De).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Ue(
      n(this, d),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Ue(
      n(this, d),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), m(this, y, xe).call(this), m(this, y, je).call(this), n(this, d).removeObserver(this);
  }
  setOptions(e, s) {
    const r = this.options, i = n(this, d);
    if (this.options = n(this, P).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof x(this.options.enabled, n(this, d)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    m(this, y, ke).call(this), n(this, d).setOptions(this.options), r._defaulted && !we(this.options, r) && n(this, P).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: n(this, d),
      observer: this
    });
    const o = this.hasListeners();
    o && ze(
      n(this, d),
      i,
      this.options,
      r
    ) && m(this, y, ae).call(this), this.updateResult(s), o && (n(this, d) !== i || x(this.options.enabled, n(this, d)) !== x(r.enabled, n(this, d)) || fe(this.options.staleTime, n(this, d)) !== fe(r.staleTime, n(this, d))) && m(this, y, Pe).call(this);
    const a = m(this, y, Ie).call(this);
    o && (n(this, d) !== i || x(this.options.enabled, n(this, d)) !== x(r.enabled, n(this, d)) || a !== n(this, L)) && m(this, y, Te).call(this, a);
  }
  getOptimisticResult(e) {
    const s = n(this, P).getQueryCache().build(n(this, P), e), r = this.createResult(s, e);
    return It(this, r) && (c(this, F, r), c(this, se, this.options), c(this, B, n(this, d).state)), r;
  }
  getCurrentResult() {
    return n(this, F);
  }
  trackResult(e, s) {
    const r = {};
    return Object.keys(e).forEach((i) => {
      Object.defineProperty(r, i, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(i), s == null || s(i), e[i])
      });
    }), r;
  }
  trackProp(e) {
    n(this, ie).add(e);
  }
  getCurrentQuery() {
    return n(this, d);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const s = n(this, P).defaultQueryOptions(e), r = n(this, P).getQueryCache().build(n(this, P), s);
    return r.fetch().then(() => this.createResult(r, s));
  }
  fetch(e) {
    return m(this, y, ae).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), n(this, F)));
  }
  createResult(e, s) {
    var Ke;
    const r = n(this, d), i = this.options, o = n(this, F), a = n(this, B), u = n(this, se), S = e !== r ? e.state : n(this, oe), { state: v } = e;
    let h = { ...v }, R = !1, g;
    if (s._optimisticResults) {
      const O = this.hasListeners(), Z = !O && Ge(e, s), W = O && ze(e, r, s, i);
      (Z || W) && (h = {
        ...h,
        ...it(v.data, e.options)
      }), s._optimisticResults === "isRestoring" && (h.fetchStatus = "idle");
    }
    let { error: w, errorUpdatedAt: b, status: p } = h;
    if (s.select && h.data !== void 0)
      if (o && h.data === (a == null ? void 0 : a.data) && s.select === n(this, he))
        g = n(this, re);
      else
        try {
          c(this, he, s.select), g = s.select(h.data), g = Oe(o == null ? void 0 : o.data, g, s), c(this, re, g), c(this, k, null);
        } catch (O) {
          c(this, k, O);
        }
    else
      g = h.data;
    if (s.placeholderData !== void 0 && g === void 0 && p === "pending") {
      let O;
      if (o != null && o.isPlaceholderData && s.placeholderData === (u == null ? void 0 : u.placeholderData))
        O = o.data;
      else if (O = typeof s.placeholderData == "function" ? s.placeholderData(
        (Ke = n(this, ne)) == null ? void 0 : Ke.state.data,
        n(this, ne)
      ) : s.placeholderData, s.select && O !== void 0)
        try {
          O = s.select(O), c(this, k, null);
        } catch (Z) {
          c(this, k, Z);
        }
      O !== void 0 && (p = "success", g = Oe(
        o == null ? void 0 : o.data,
        O,
        s
      ), R = !0);
    }
    n(this, k) && (w = n(this, k), g = n(this, re), b = Date.now(), p = "error");
    const E = h.fetchStatus === "fetching", U = p === "pending", N = p === "error", ce = U && E, le = g !== void 0, j = {
      status: p,
      fetchStatus: h.fetchStatus,
      isPending: U,
      isSuccess: p === "success",
      isError: N,
      isInitialLoading: ce,
      isLoading: ce,
      data: g,
      dataUpdatedAt: h.dataUpdatedAt,
      error: w,
      errorUpdatedAt: b,
      failureCount: h.fetchFailureCount,
      failureReason: h.fetchFailureReason,
      errorUpdateCount: h.errorUpdateCount,
      isFetched: h.dataUpdateCount > 0 || h.errorUpdateCount > 0,
      isFetchedAfterMount: h.dataUpdateCount > S.dataUpdateCount || h.errorUpdateCount > S.errorUpdateCount,
      isFetching: E,
      isRefetching: E && !U,
      isLoadingError: N && !le,
      isPaused: h.fetchStatus === "paused",
      isPlaceholderData: R,
      isRefetchError: N && le,
      isStale: Me(e, s),
      refetch: this.refetch,
      promise: n(this, M)
    };
    if (this.options.experimental_prefetchInRender) {
      const O = (de) => {
        j.status === "error" ? de.reject(j.error) : j.data !== void 0 && de.resolve(j.data);
      }, Z = () => {
        const de = c(this, M, j.promise = Fe());
        O(de);
      }, W = n(this, M);
      switch (W.status) {
        case "pending":
          e.queryHash === r.queryHash && O(W);
          break;
        case "fulfilled":
          (j.status === "error" || j.data !== W.value) && Z();
          break;
        case "rejected":
          (j.status !== "error" || j.error !== W.reason) && Z();
          break;
      }
    }
    return j;
  }
  updateResult(e) {
    const s = n(this, F), r = this.createResult(n(this, d), this.options);
    if (c(this, B, n(this, d).state), c(this, se, this.options), n(this, B).data !== void 0 && c(this, ne, n(this, d)), we(r, s))
      return;
    c(this, F, r);
    const i = {}, o = () => {
      if (!s)
        return !0;
      const { notifyOnChangeProps: a } = this.options, u = typeof a == "function" ? a() : a;
      if (u === "all" || !u && !n(this, ie).size)
        return !0;
      const l = new Set(
        u ?? n(this, ie)
      );
      return this.options.throwOnError && l.add("error"), Object.keys(n(this, F)).some((S) => {
        const v = S;
        return n(this, F)[v] !== s[v] && l.has(v);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && o() && (i.listeners = !0), m(this, y, ut).call(this, { ...i, ...e });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && m(this, y, De).call(this);
  }
}, P = new WeakMap(), d = new WeakMap(), oe = new WeakMap(), F = new WeakMap(), B = new WeakMap(), se = new WeakMap(), M = new WeakMap(), k = new WeakMap(), he = new WeakMap(), re = new WeakMap(), ne = new WeakMap(), G = new WeakMap(), z = new WeakMap(), L = new WeakMap(), ie = new WeakMap(), y = new WeakSet(), ae = function(e) {
  m(this, y, ke).call(this);
  let s = n(this, d).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (s = s.catch(ge)), s;
}, Pe = function() {
  m(this, y, xe).call(this);
  const e = fe(
    this.options.staleTime,
    n(this, d)
  );
  if (V || n(this, F).isStale || !Se(e))
    return;
  const r = et(n(this, F).dataUpdatedAt, e) + 1;
  c(this, G, setTimeout(() => {
    n(this, F).isStale || this.updateResult();
  }, r));
}, Ie = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(n(this, d)) : this.options.refetchInterval) ?? !1;
}, Te = function(e) {
  m(this, y, je).call(this), c(this, L, e), !(V || x(this.options.enabled, n(this, d)) === !1 || !Se(n(this, L)) || n(this, L) === 0) && c(this, z, setInterval(() => {
    (this.options.refetchIntervalInBackground || tt.isFocused()) && m(this, y, ae).call(this);
  }, n(this, L)));
}, De = function() {
  m(this, y, Pe).call(this), m(this, y, Te).call(this, m(this, y, Ie).call(this));
}, xe = function() {
  n(this, G) && (clearTimeout(n(this, G)), c(this, G, void 0));
}, je = function() {
  n(this, z) && (clearInterval(n(this, z)), c(this, z, void 0));
}, ke = function() {
  const e = n(this, P).getQueryCache().build(n(this, P), this.options);
  if (e === n(this, d))
    return;
  const s = n(this, d);
  c(this, d, e), c(this, oe, e.state), this.hasListeners() && (s == null || s.removeObserver(this), e.addObserver(this));
}, ut = function(e) {
  Ae.batch(() => {
    e.listeners && this.listeners.forEach((s) => {
      s(n(this, F));
    }), n(this, P).getQueryCache().notify({
      query: n(this, d),
      type: "observerResultsUpdated"
    });
  });
}, Ye);
function Pt(t, e) {
  return x(e.enabled, t) !== !1 && t.state.data === void 0 && !(t.state.status === "error" && e.retryOnMount === !1);
}
function Ge(t, e) {
  return Pt(t, e) || t.state.data !== void 0 && Ue(t, e, e.refetchOnMount);
}
function Ue(t, e, s) {
  if (x(e.enabled, t) !== !1) {
    const r = typeof s == "function" ? s(t) : s;
    return r === "always" || r !== !1 && Me(t, e);
  }
  return !1;
}
function ze(t, e, s, r) {
  return (t !== e || x(r.enabled, t) === !1) && (!s.suspense || t.state.status !== "error") && Me(t, s);
}
function Me(t, e) {
  return x(e.enabled, t) !== !1 && t.isStaleByTime(fe(e.staleTime, t));
}
function It(t, e) {
  return !we(t.getCurrentResult(), e);
}
var ot = T.createContext(
  void 0
), Tt = (t) => {
  const e = T.useContext(ot);
  if (t)
    return t;
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, ts = ({
  client: t,
  children: e
}) => (T.useEffect(() => (t.mount(), () => {
  t.unmount();
}), [t]), /* @__PURE__ */ pt.jsx(ot.Provider, { value: t, children: e })), ht = T.createContext(!1), Dt = () => T.useContext(ht);
ht.Provider;
function xt() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
var jt = T.createContext(xt()), kt = () => T.useContext(jt);
function Ut(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
function Ve() {
}
var Qt = (t, e) => {
  (t.suspense || t.throwOnError || t.experimental_prefetchInRender) && (e.isReset() || (t.retryOnMount = !1));
}, qt = (t) => {
  T.useEffect(() => {
    t.clearReset();
  }, [t]);
}, At = ({
  result: t,
  errorResetBoundary: e,
  throwOnError: s,
  query: r
}) => t.isError && !e.isReset() && !t.isFetching && r && Ut(s, [t.error, r]), Mt = (t, e) => e.state.data === void 0, Lt = (t) => {
  const e = t.staleTime;
  t.suspense && (t.staleTime = typeof e == "function" ? (...s) => Math.max(e(...s), 1e3) : Math.max(e ?? 1e3, 1e3), typeof t.gcTime == "number" && (t.gcTime = Math.max(t.gcTime, 1e3)));
}, Nt = (t, e) => t.isLoading && t.isFetching && !e, Kt = (t, e) => (t == null ? void 0 : t.suspense) && e.isPending, $e = (t, e, s) => e.fetchOptimistic(t).catch(() => {
  s.clearReset();
});
function ct(t, e, s) {
  var h, R, g, w, b;
  if (process.env.NODE_ENV !== "production" && (typeof t != "object" || Array.isArray(t)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Tt(s), i = Dt(), o = kt(), a = r.defaultQueryOptions(t);
  (R = (h = r.getDefaultOptions().queries) == null ? void 0 : h._experimental_beforeQuery) == null || R.call(
    h,
    a
  ), a._optimisticResults = i ? "isRestoring" : "optimistic", Lt(a), Qt(a, o), qt(o);
  const u = !r.getQueryCache().get(a.queryHash), [l] = T.useState(
    () => new e(
      r,
      a
    )
  ), S = l.getOptimisticResult(a), v = !i && t.subscribed !== !1;
  if (T.useSyncExternalStore(
    T.useCallback(
      (p) => {
        const E = v ? l.subscribe(Ae.batchCalls(p)) : Ve;
        return l.updateResult(), E;
      },
      [l, v]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), T.useEffect(() => {
    l.setOptions(a, { listeners: !1 });
  }, [a, l]), Kt(a, S))
    throw $e(a, l, o);
  if (At({
    result: S,
    errorResetBoundary: o,
    throwOnError: a.throwOnError,
    query: r.getQueryCache().get(a.queryHash)
  }))
    throw S.error;
  if ((w = (g = r.getDefaultOptions().queries) == null ? void 0 : g._experimental_afterQuery) == null || w.call(
    g,
    a,
    S
  ), a.experimental_prefetchInRender && !V && Nt(S, i)) {
    const p = u ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      $e(a, l, o)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (b = r.getQueryCache().get(a.queryHash)) == null ? void 0 : b.promise
    );
    p == null || p.catch(Ve).finally(() => {
      l.updateResult();
    });
  }
  return a.notifyOnChangeProps ? S : l.trackResult(S);
}
function _t(t, e) {
  return ct(t, at, e);
}
function Ht(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === ye && console.error("skipToken is not allowed for useSuspenseQuery"), ct(
    {
      ...t,
      enabled: !0,
      suspense: !0,
      throwOnError: Mt,
      placeholderData: void 0
    },
    at,
    e
  );
}
const $ = (...t) => {
  const e = t.filter((s) => !!s).map((s) => s.replace(/(^\/+|\/+$)/g, "")).join("/").replace(/(^\/+|\/+$)/g, "");
  return e ? `/${e}` : "/";
}, Le = (t, e) => {
  for (const s of t) {
    const r = Ne(s, e);
    if (r !== void 0) return r;
  }
}, Ne = (t, e, s = []) => {
  const r = e(t, s);
  if (r !== void 0) return r;
  if (t.type === "category")
    for (const i of t.items) {
      const o = Ne(i, e, [
        ...s,
        t
      ]);
      if (o !== void 0) return o;
    }
}, ss = () => {
  const t = pe(), s = dt().sidebar;
  return Le(s, (r) => {
    if (r.type === "doc" && $(r.id) === t.pathname)
      return r;
  });
}, rs = (t) => {
  const e = pe();
  return Ne(t, (s) => {
    if (s.type === "category" && s.link && $(s.link.id) === e.pathname || s.type === "doc" && $(s.id) === e.pathname)
      return !0;
  });
}, ns = () => {
  const t = pe().pathname, s = dt().sidebar;
  let r, i, o = !1;
  return Le(s, (a) => {
    const u = a.type === "doc" ? $(a.id) : a.type === "category" && a.link ? $(a.link.id) : void 0;
    if (u) {
      if (o)
        return i = { label: a.label, id: u }, !0;
      t === u ? o = !0 : r = { label: a.label, id: u };
    }
  }), { prev: r, next: i };
}, Bt = ft(
  void 0
), lt = () => {
  const t = yt(Bt);
  if (!t)
    throw new Error("useZudoku must be used within a ZudokuProvider.");
  return t;
}, is = () => {
  const { getApiIdentities: t } = lt();
  return _t({
    queryFn: t,
    queryKey: ["api-identities"]
  });
}, dt = () => {
  const { getPluginSidebar: t, sidebars: e, topNavigation: s } = lt(), r = pe(), i = Object.entries(e).find(([, u]) => Le(u, (l) => {
    if ((l.type === "doc" ? $(l.id) : l.type === "category" && l.link ? $(l.link.id) : void 0) === r.pathname)
      return l;
  })), o = s.find((u) => u.id === (i == null ? void 0 : i[0])) ?? s.find((u) => bt(u.id, r.pathname)), { data: a } = Ht({
    queryFn: () => t(r.pathname),
    queryKey: ["plugin-sidebar", r.pathname]
  });
  return {
    sidebar: [...i ? i[1] : [], ...a],
    topNavItem: o
  };
};
export {
  ye as A,
  ts as B,
  rs as C,
  dt as D,
  Le as E,
  es as Q,
  Ot as R,
  Qe as S,
  Bt as Z,
  lt as a,
  ss as b,
  wt as c,
  ns as d,
  Tt as e,
  Ve as f,
  Ut as g,
  Re as h,
  is as i,
  $ as j,
  _t as k,
  mt as l,
  Wt as m,
  Ae as n,
  Jt as o,
  ge as p,
  gt as q,
  Yt as r,
  we as s,
  Xt as t,
  Ht as u,
  tt as v,
  st as w,
  fe as x,
  Zt as y,
  qe as z
};
//# sourceMappingURL=ZudokuContext-DeQZEp-x.js.map
